import type { HTMLAttributes, ReactNode } from 'react';

/**
 * Spec 230 — the standalone container: dialogs, toasts, empty states.
 * `flat` is the sunken well variant (`.hub-plate--flat`).
 */
export interface PlateProps extends HTMLAttributes<HTMLDivElement> {
  flat?: boolean;
  children?: ReactNode;
}

export function Plate({ flat, className, children, ...rest }: PlateProps) {
  const cls = ['hub-plate', flat ? 'hub-plate--flat' : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}
